import { render, staticRenderFns } from "./customer-notes.vue?vue&type=template&id=86560a0a&scoped=true"
import script from "./customer-notes.ts?vue&type=script&lang=ts&external"
export * from "./customer-notes.ts?vue&type=script&lang=ts&external"
import style0 from "./customer-notes.scss?vue&type=style&index=0&id=86560a0a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86560a0a",
  null
  
)

export default component.exports